import { SectionModel } from './section.model';
import { PermissionModel } from './permission.model';

export class UserModel {
  public id: number = null;
  public login: string = null;
  public password: string = null;
  public name: string = null;
  public firstName: string = null;
  public fullName: string = null;
  public serialNumber: string = null;
  public type: number = null;
  public dateBegin = null;
  public dateEnd = null;
  public entity: number = null;
  public management: number = null;
  public email: string = null;
  public administrator: boolean = false;
  public active: boolean = true;
  public comment: string = null;
  public sections: SectionModel[] = [];
  public permissions: PermissionModel[] = [];

  constructor() {}

  public getFullName(): string {
    return this.firstName + ' ' + this.name;
  }

  public fromJSON(json) {
    for (let propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
